"use client";

import _createForOfIteratorHelper from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { isBackdrop } from "./63XF7ACK.js";
import { walkTreeOutside } from "./AOUGVQZ3.js";
import { setAttribute } from "./K2ZF5NU7.js"; // src/dialog/utils/disable-accessibility-tree-outside.ts

function hideElementFromAccessibilityTree(element) {
  return setAttribute(element, "aria-hidden", "true");
}

function disableAccessibilityTreeOutside(id, elements) {
  var cleanups = [];
  var ids = elements.map(function (el) {
    return el == null ? void 0 : el.id;
  });
  walkTreeOutside(id, elements, function (element) {
    if (isBackdrop.apply(void 0, [element].concat(_toConsumableArray(ids)))) return;
    cleanups.unshift(hideElementFromAccessibilityTree(element));
  });

  var restoreAccessibilityTree = function restoreAccessibilityTree() {
    var _iterator = _createForOfIteratorHelper(cleanups),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var cleanup = _step.value;
        cleanup();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  return restoreAccessibilityTree;
}

export { hideElementFromAccessibilityTree, disableAccessibilityTreeOutside };